/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_Type_Pricedrop1Inputs */

const he_extension_tracker_type_pricedrop1 = /** @type {(inputs: Extension_Tracker_Type_Pricedrop1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ירידת מחיר`)
};

const en_extension_tracker_type_pricedrop1 = /** @type {(inputs: Extension_Tracker_Type_Pricedrop1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drop`)
};

/**
* | output |
* | --- |
* | "Price drop" |
*
* @param {Extension_Tracker_Type_Pricedrop1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_type_pricedrop1 = /** @type {((inputs?: Extension_Tracker_Type_Pricedrop1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Type_Pricedrop1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_type_pricedrop1(inputs)
	return en_extension_tracker_type_pricedrop1(inputs)
});
export { extension_tracker_type_pricedrop1 as "extension_tracker_type_priceDrop" }